// extracted by mini-css-extract-plugin
export default {"root":"QuizOption_root__O0V-s"};